module.exports = __webpack_public_path__ + "img/phone.3a7dcb86.svg";